import React, { Component } from "react";
import { DKLabel, DKButton, DKLine } from "deskera-ui-library";

import ic_contacts from "../../../assets/menu/ic_user.png";
import ic_deals from "../../../assets/menu/ic_deals.png";
import ic_campaign from "../../../assets/menu/ic_campaign.png";
import ic_funnel from "../../../assets/menu/ic_funnel.png";
import ic_landing_page from "../../../assets/menu/ic_langing_page.png";
import ic_forms from "../../../assets/menu/ic_form.png";
import ic_automation from "../../../assets/menu/ic_automation.png";

import { showFormPopup } from "../../menu/AddNewRecordPopup";
import { PRODUCTS, TABLES, TABLE_DISPLAY_NAME } from "../../../managers/TableManger";
import RouteManager, { PAGE_ROUTES } from "../../../managers/RouteManager";
import { DealManager } from "../../../managers/DealManager";
import ContactManager from "../../../managers/ContactManager";
import FormManager from "../../forms/FormManager";
import FormsTemplateManager from "../../forms/templates/TemplateManager";
import CandidatetCard from "./CandidateCard";
import JobFormCard from "./JobFormCard";
import JobPipelineCard from "./JobPipelineCard";
import ApiConstants from "../../../constants/ApiConstants";
import PayrollCard from "./PayrollCard";
import EleaveCard from "./EleaveCard";
import ExpenseCard from "./ExpenseCard";
import JobPipelineService from "./JobPipeline";
import ExpenseClaimTrends from "./ExpenseClaimTrendsCard";
import PendingClaimsCard from "./PendingClaimsCard";
import ClaimsByCategoryCard from "./ClaimsByCategoryCard";
import MyClaimsCard from "./MyClaimsCard";
import ApprovedClaimsCard from "./ApprovedClaimsCard";
import ExpenseClaimListService from "../../../services/ExpenseClaimListService";
import TeamAttendanceCard from "./TeamAttendanceCard";
import PermissionUtils, { ACTION, MODULE, TABLE_MODULE_MAP } from "../../user-permissions/PermissionUtils";

export const PRODUCT_DESCRIPTION = {
  [TABLES.CONTACT]: "See all your newly added contact here",
  [TABLES.DEAL]: "Deals won or loss summary",
  [TABLES.CAMPAIGN]: "Recent Campaigns and modify it",
  [TABLES.FUNNEL]: "See all your funnels here",
  [TABLES.LANDING_PAGE]: "See how your landing pages are performing",
  [TABLES.FORM]: "Create and monitor Forms",
  [TABLES.AUTOMATION]: "Start automation to increase productivity",
  [TABLES.PEOPLE_AUTOMATION]: "Start automation to increase productivity",
};
export const PRODUCT_ICON = {
  [TABLES.CONTACT]: ic_contacts,
  [TABLES.DEAL]: ic_deals,
  [TABLES.CAMPAIGN]: ic_campaign,
  [TABLES.FUNNEL]: ic_funnel,
  [TABLES.LANDING_PAGE]: ic_landing_page,
  [TABLES.FORM]: ic_forms,
  [TABLES.AUTOMATION]: ic_automation,
  [TABLES.CANDIDATE]: ic_contacts,
  [TABLES.JOB_PIPELINE]: ic_deals,
  [TABLES.JOB_FORMS]: ic_forms,
  [PRODUCTS.PAYROLL]: ic_contacts,
  [PRODUCTS.ELEAVE]: ic_contacts,
  [PRODUCTS.EXPENSE]: ic_contacts,
  [TABLES.PEOPLE_AUTOMATION]: ic_automation,
};
export const PRODUCT_BADGE_COLOR = {
  [TABLES.CONTACT]: "bg-gray2",
  [TABLES.DEAL]: "bg-gray2",
  [TABLES.CAMPAIGN]: "bg-gray2",
  [TABLES.FUNNEL]: "bg-gray2",
  [TABLES.LANDING_PAGE]: "bg-gray2",
  [TABLES.FORM]: "bg-gray2",
  [TABLES.AUTOMATION]: "bg-gray2",
  [TABLES.CANDIDATE]: "bg-gray2",
  [TABLES.JOB_PIPELINE]: "bg-gray2",
  [TABLES.JOB_FORMS]: "bg-gray2",
  [TABLES.PEOPLE_EXPENSE_PENDING_CLAIMS]: "bg-gray2"
};
export const PRODUCT_BADGE_COLOR1 = {
  [TABLES.CONTACT]: "data-grid-badge-color-4",
  [TABLES.DEAL]: "data-grid-badge-color-8",
  [TABLES.CAMPAIGN]: "data-grid-badge-color-6",
  [TABLES.FUNNEL]: "data-grid-badge-color-5",
  [TABLES.LANDING_PAGE]: "data-grid-badge-color-7",
  [TABLES.FORM]: "data-grid-badge-color-9",
  [TABLES.AUTOMATION]: "data-grid-badge-color-10",
  [TABLES.CANDIDATE]: "data-grid-badge-color-4",
  [TABLES.JOB_PIPELINE]: "data-grid-badge-color-8",
  [TABLES.JOB_FORMS]: "data-grid-badge-color-9"
};

/*
PROPS
- product
- isGraphDesign
*/

class DashboardCard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      totalCount: 0,
    };
  }
  render() {
    return (
      <>
        {!this.props.isGraphDesign && (
          <div className={`${this.props.module !== TABLES.TEAM_ATTENDANCE? "pb-l dashboard-card ":" dashboard-mid-card position-relative "} bg-white p-h-xl pt-r  border-m border-radius-m border-box  column align-items-center parent-width`}>
            <div
              className="column align-items-start parent-width custom-scroll"
              style={{
                overflow: "hidden",
              }}
            >
              { <div className="row align-items-center">
                <DKLabel
                  text={TABLE_DISPLAY_NAME[this.props.module]}
                  className="fw-m fs-m"
                />
                {this.getTotalCountView()}
              </div>}
            </div>
            <div
              className={`${this.props.module !== TABLES.TEAM_ATTENDANCE ? "mt-m  custom-scroll":""}  mb-s parent-width `} 
              style={{
                height: this.props.module !== TABLES.TEAM_ATTENDANCE ? 190:'',
                overflowX: this.props.module !== TABLES.TEAM_ATTENDANCE ? "hidden":"inherit",
                scrollbarWidth: "thin",
              }}
            >
              {this.getProductCard(this.props)}
            </div>
            {(this.props.module !== TABLES.AUTOMATION && this.props.module !== TABLES.TEAM_ATTENDANCE) && <DKLine />}
            {(this.props.module !== TABLES.AUTOMATION &&
              this.props.module !== TABLES.PEOPLE_EXPENSE_APPROVED_CLAIMS &&
              this.props.module !== TABLES.TEAM_ATTENDANCE) && (
              <div className="row-reverse mt-l">
                {this.props.module !== TABLES.PEOPLE_EXPENSE_MY_CLAIMS &&
                this.props.module !== TABLES.TEAM_ATTENDANCE && 
                PermissionUtils.hasAccess(MODULE[TABLE_MODULE_MAP[this.props.module]], [ACTION.CREATE]) && (
                  <DKButton
                    title={this.getAddButtonText()}
                    className="bg-app text-white fs-r ml-m"
                    onClick={() => this.onCreateNew(this.props.module)}
                  />
                )}
                {this.props.module !== TABLES.PEOPLE_EXPENSE_PENDING_CLAIMS &&
                  this.props.module !== TABLES.PEOPLE_EXPENSE_APPROVED_CLAIMS &&
                  PermissionUtils.hasAccess(MODULE[TABLE_MODULE_MAP[this.props.module]], [ACTION.VIEW]) && (
                  <DKButton
                    onClick={() => this.viewDetailsHandler(this.props.module)}
                    title="View All"
                    className="bg-gray1 border-m"
                  />
                )}
              </div>
            )}
          </div>
        )}
        {this.props.isGraphDesign && (this.getProductCard())}
      </>
    );
  }
  onCountUpdated = (count) => {
    this.setState({
      totalCount: count,
    });
  };
  onCreateNew = (module) => {
    switch (module) {
      case TABLES.CANDIDATE:
        showFormPopup({
          tableName: TABLES.CANDIDATE,
          defaultValues: ContactManager.getDefaultValues(),
          displayName: TABLES.CANDIDATE,
          inputData: JobPipelineService.getPipelineData(JobPipelineService.pipelineData),
          popupClass: 'custom-scroll'
        });
        break;
      case TABLES.JOB_PIPELINE:
        showFormPopup({
          tableName: TABLES.JOB_PIPELINE,
          defaultValues: DealManager.getDefaultValues(),
          displayName: TABLE_DISPLAY_NAME[TABLES.JOB_PIPELINE],
        });
        break
      case TABLES.JOB_FORMS: {
        FormManager.setFormData(null);
        FormsTemplateManager.setSelectedTemplateId(null);
        RouteManager.navigateToPage(PAGE_ROUTES.SELECT_FORM_TEMPLATE);
        break;
      }
      case TABLES.PEOPLE_EXPENSE_PENDING_CLAIMS: {
        ExpenseClaimListService.activeTab = "PENDING";
        RouteManager.navigateToPage(PAGE_ROUTES.EXPENSE.EXPENSE_CLAIM);
        break;
      }
      default:
        break;
    }
  };
  getProductCard(props) {
    switch (this.props.module) {
      case TABLES.CANDIDATE:
        return <CandidatetCard onCountUpdated={this.onCountUpdated} />;
      case TABLES.JOB_PIPELINE:
        return <JobPipelineCard onCountUpdated={this.onCountUpdated} />;
      case TABLES.JOB_FORMS:
        return <JobFormCard onCountUpdated={this.onCountUpdated} />;
      case PRODUCTS.PAYROLL:
        return <PayrollCard product={this.props.module}/>
      case PRODUCTS.ELEAVE:
        return <EleaveCard product={this.props.module} />
      case PRODUCTS.EXPENSE:
        return <ExpenseCard product={this.props.module} />
      case PRODUCTS.EXPENSE_TREND:
        return <ExpenseClaimTrends />
      case TABLES.PEOPLE_EXPENSE_PENDING_CLAIMS:
        return <PendingClaimsCard module={this.props.module} onCountUpdated={this.onCountUpdated} />
      case TABLES.PEOPLE_EXPENSE_APPROVED_CLAIMS:
        return <ApprovedClaimsCard module={this.props.module} />
      case TABLES.PEOPLE_EXPENSE_CLAIMS_BREAKDOWN_GROUP:
        return <ClaimsByCategoryCard module={this.props.module} type="GROUP" />
      case TABLES.PEOPLE_EXPENSE_CLAIMS_BREAKDOWN_CATEGORY:
        return <ClaimsByCategoryCard module={this.props.module}  type="CATEGORY" />
      case TABLES.PEOPLE_EXPENSE_MY_CLAIMS:
        return <MyClaimsCard module={this.props.module} />
      case TABLES.TEAM_ATTENDANCE:
        return <TeamAttendanceCard {...props}/>
      default:
        return null;
    }
  }
  viewDetailsHandler = (module) => {
    switch (module) {
      case TABLES.CANDIDATE:
        return RouteManager.navigateToPage(PAGE_ROUTES.CANDIDATE);
      case TABLES.JOB_PIPELINE:
        return RouteManager.navigateToPage(PAGE_ROUTES.JOB_PIPELINE);
      case TABLES.JOB_FORMS:
        return RouteManager.navigateToPage(PAGE_ROUTES.JOB_FORMS);
      case PRODUCTS.PAYROLL:
        return window.open(ApiConstants.PRODUCT_URL_PEOPLE, "_blank");
      case PRODUCTS.ELEAVE:
        return window.open(ApiConstants.PRODUCT_URL_ELEAVE, "_blank");
      case PRODUCTS.EXPENSE:
        return window.open(ApiConstants.PRODUCT_URL_EXPENSE, "_blank");
      case TABLES.PEOPLE_EXPENSE_MY_CLAIMS:
        return RouteManager.navigateToPage(PAGE_ROUTES.EXPENSE.EXPENSE_CLAIM);
      default:
        return RouteManager.navigateToHome();
    }
  };
  getTotalCountView = () => {
    return (
      <>
        <DKLabel
          className={" ml-s fw-m border-radius-s "}
          text={
            this.state.totalCount > 0 ? `<b>(${this.state.totalCount})</b>` : ""
          }
        />
      </>
    );
  };

  getAddButtonText() {
    switch (this.props.module) {
      case TABLES.CANDIDATE:
        return "+ Add a candidate";
      case TABLES.JOB_PIPELINE:
        return "+ Add a pipeline";
      case TABLES.CAMPAIGN:
        return "+ Create a campaign";
      case TABLES.FUNNEL:
        return "+ New Funnel";
      case TABLES.LANDING_PAGE:
        return "+ New Landing page";
      case TABLES.JOB_FORMS:
        return "+ Create a form";
      case TABLES.AUTOMATION:
        return "+ New Automation";
      case TABLES.PEOPLE_EXPENSE_PENDING_CLAIMS:
        return "Review Now >";
      default:
        return "+ New";
    }
  }
  routeToRespectiveApps(module) {
    let routeTo = "";
    switch(module) {
      case PRODUCTS.PAYROLL:
        routeTo = ApiConstants.PRODUCT_URL_PEOPLE;
        break;
      case PRODUCTS.ELEAVE:
        routeTo = ApiConstants.PRODUCT_URL_ELEAVE;
        break;
      case PRODUCTS.EXPENSE:
        routeTo = ApiConstants.PRODUCT_URL_EXPENSE;
        break;
    }
    window.open(routeTo, "_blank");
  }
}

export default DashboardCard;
